var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error",
    clipPath: "url(#clip0_2243_630)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99992 8.88888V3.99999M8.02726 11.1667C7.96096 11.1667 7.89737 11.1403 7.85049 11.0934C7.8036 11.0466 7.77726 10.983 7.77726 10.9167C7.77726 10.8504 7.8036 10.7868 7.85049 10.7399C7.89737 10.693 7.96096 10.6667 8.02726 10.6667C8.09357 10.6667 8.15716 10.693 8.20404 10.7399C8.25092 10.7868 8.27726 10.8504 8.27726 10.9167C8.27726 10.983 8.25092 11.0466 8.20404 11.0934C8.15716 11.1403 8.09357 11.1667 8.02726 11.1667ZM7.99992 14.6667C11.6817 14.6667 14.6666 11.6818 14.6666 8C14.6666 4.31822 11.6817 1.33333 7.99992 1.33333C4.31814 1.33333 1.33325 4.31822 1.33325 8C1.33325 11.6818 4.31814 14.6667 7.99992 14.6667Z",
    stroke: "#D31313",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2243_630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.782f776497c6842e9cf32ebf658d3c98.svg";
export { ForwardRef as ReactComponent };